import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItemButton, TextField } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const OverlayContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(3),
  left: theme.spacing(3),
  zIndex: theme.zIndex.modal - 1,
  '& .MuiPaper-root': {
    backgroundColor: 'rgb(50 50 50)!important',
    border: '1px solid #404040',
  },
}));

export const MainAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: 20,
  boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
  overflow: 'hidden',
  width: 400,
  backdropFilter: 'blur(16px)',
  background: alpha(theme.palette.background.paper, 0.95),
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
  transition: 'box-shadow 0.3s ease',
  '& :hover': {
    backgroundColor: 'transparent !important',
  },
}));

export const MainAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: 48,
  margin: 0,
  borderRadius: '20px 20px 0 0',
  '& .MuiAccordionSummary-content': { margin: 0 },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.text.secondary,
    transition: 'transform 0.3s ease, color 0.3s ease',
    '&.Mui-expanded': {
      color: theme.palette.primary.main,
    },
  },
  '&:hover .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main,
  },
}));

export const MainAccordionDetails = styled(AccordionDetails)(() => ({
  padding: 0,
  maxHeight: 'calc(37vh)',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  '&::-webkit-scrollbar': {
    width: 6,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: alpha('#aaa', 0.2),
    borderRadius: 3,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: alpha('#aaa', 0.3),
  },
}));

export const SearchContainer = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${alpha('#aaa', 0.06)}`,
  borderTop: `1px solid ${alpha('#aaa', 0.06)}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 18px',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: theme.spacing(2),
    right: theme.spacing(2),
    height: 1,
    background: `linear-gradient(90deg, transparent, ${alpha('#aaa', 0.1)}, transparent)`,
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: alpha('#aaa', 0.04),
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha('#aaa', 0.08),
    },
    '&.Mui-focused': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha('#aaa', 0.1),
    },
  },
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 2),
  },
}));

export const InspectionList = styled(List)(({ theme }) => ({
  padding: theme.spacing(0.5, 0),
}));

export const InspectionItem = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(0.2, 3),
  borderRadius: 0,
  transition: 'all 0.2s ease',
  position: 'relative',
  '&:not(:last-child)::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: theme.spacing(6),
    right: theme.spacing(3),
    height: 1,
    background: alpha('#aaa', 0.04),
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    '&::after': {
      background: alpha(theme.palette.primary.main, 0.08),
    },
  },
  '& .MuiListItemIcon-root': {
    minWidth: 40,
    opacity: 0.8,
    transition: 'opacity 0.2s ease',
  },
  '&:hover .MuiListItemIcon-root': {
    opacity: 1,
  },
}));

export const EmptyStateBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(8, 2),
  color: theme.palette.text.secondary,
  height: 200,
  borderTop: `1px solid ${alpha('#aaa', 0.06)}`,
}));
